// @flow

import React from 'react';
import T from 'prop-types';
import * as Modules from 'components/modules';
import Carousel from 'components/modules/Carousel';
import * as selectors from 'selectors';
import { connect } from 'react-redux';
import styles from './sliderFullscreenSection.css';
import * as s from './styled';

class SliderFullscreenSection extends React.Component {
  constructor(props) {
    super(props);
    this.isTextPresent =
      props.title ||
      props.subtitle ||
      (props.description &&
        (props.description[0] || props.description.length > 1));
  }

  state = {
    intoView: false,
    index: 0,
  };

  componentWillReceiveProps(nextProps) {
    const prevIntoView = this.props.scrollPosition === this.props.scrollIndex;
    const nextIntoView = nextProps.scrollPosition === this.props.scrollIndex;
    if (prevIntoView === nextIntoView) {
      return;
    }

    if (nextIntoView) {
      this.setState({ intoView: true });
    } else {
      this.setState(() => ({ intoView: false }));
    }
  }

  nextSlide = () => {
    this.setState((prevState) => {
      const nextIndex =
        prevState.index === this.props.images.length - 1
          ? 0
          : prevState.index + 1;
      return {
        index: nextIndex,
      };
    });
  };
  prevSlide = () => {
    this.setState((prevState) => {
      const nextIndex =
        prevState.index === 0
          ? this.props.images.length - 1
          : prevState.index - 1;
      return {
        index: nextIndex,
      };
    });
  };

  render() {
    const {
      title,
      subtitle,
      description,
      images,
      height,
      textAlign,
      textHorizAlign,
      colors,
    } = this.props;
    const { intoView, index: activeIndex } = this.state;

    return (
      <div>
        <s.Section height={height} backgroundImage={images[0].src}>
          <Carousel
            dragging
            slideIndex={this.state.index}
            afterSlide={index => this.setState({ index })}
            wrapAround
            renderTopLeftControls={() =>
              description.length === 1 && (
                <s.TextOuterWrapperDesktop
                  textAlign={textAlign}
                  textHorizAlign={textHorizAlign}
                >
                  <s.TextContent
                    textAlign={textAlign}
                    textHorizAlign={textHorizAlign}
                  >
                    <Modules.TextBlock1
                      description={description[0]}
                      colors={colors}
                    />
                  </s.TextContent>
                </s.TextOuterWrapperDesktop>
              )}
            renderCenterRightControls={() => (
              <button
                title="Следующий слайд"
                onClick={this.nextSlide}
                className={styles.nextSlide}
              />
            )}
            renderCenterLeftControls={() => (
              <button
                title="Предыдущий слайд"
                onClick={this.prevSlide}
                className={styles.prevSlide}
              />
            )}
          >
            {images.map((item, i) => (
              <div
                key={i}
                className={styles.sliderImg}
                style={{ backgroundImage: `url(${item.src})` }}
              >
                {this.isTextPresent &&
                  description.length > 1 && (
                    <s.TextOuterWrapperDesktop
                      textAlign={textAlign}
                      textHorizAlign={textHorizAlign}
                    >
                      <s.TextContent
                        textAlign={textAlign}
                        textHorizAlign={textHorizAlign}
                      >
                        <Modules.TextBlock1
                          description={description[i]}
                          colors={colors}
                        />
                      </s.TextContent>
                    </s.TextOuterWrapperDesktop>
                  )}
              </div>
            ))}
          </Carousel>

          <Modules.SectionKeyHandlers
            arrowRightHandler={this.nextSlide}
            arrowLeftHandler={this.prevSlide}
            active={intoView}
          />
        </s.Section>
        {this.isTextPresent && (
          <s.TextWrapperMobile backgroundColor={colors.background}>
            <s.TextContainerMobile>
              <Modules.TextBlock1
                description={
                  description.length > 1
                    ? description[activeIndex]
                    : description[0]
                }
                colors={colors}
              />
            </s.TextContainerMobile>
          </s.TextWrapperMobile>
        )}
      </div>
    );
  }
}

SliderFullscreenSection.defaultProps = {
  height: null,
  scrollPosition: null,
  description: [],
};
SliderFullscreenSection.propTypes = {
  height: T.string,
  title: T.string.isRequired,
  subtitle: T.string.isRequired,
  description: T.arrayOf(T.string),
  images: T.arrayOf(T.shape({ src: T.string, alt: T.string })).isRequired,
  scrollPosition: T.number,
  scrollIndex: T.number.isRequired,
  textAlign: T.string,
  textHorizAlign: T.string.isRequired,
  colors: T.shape({
    background: T.string,
    title: T.string,
    subtitle: T.string,
    description: T.string,
  }).isRequired,
};

const mapStateToProps = state => ({
  scrollPosition: selectors.getScrollPosition(state),
});
export default connect(mapStateToProps)(SliderFullscreenSection);



// WEBPACK FOOTER //
// ./src/components/modules/SliderFullscreenSection/SliderFullscreenSection.js